<section class="flex min-h-screen">
  <!-- Sidebar -->
  <app-sidebar></app-sidebar>
  <!-- Main Content -->
  <div class="flex flex-grow flex-col bg-neutral-white">
    <app-header
      [title]="pageTitle"
      [subtitle]="pageSubtitle"
      [buttons]="pageButtons"
      [showBackButton]="showBackButton"
      (backClick)="goBack()" />
    <main class="overflow-y-auto p-6" style="height: calc(100vh - 64px) !important">
      <router-outlet></router-outlet>
    </main>
  </div>
</section>
